import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import { StoreType } from "@reducers/types";

import {
  createDisciplineFailed,
  createDisciplineSuccess,
  updateDisciplineFailed,
  updateDisciplineSuccess,
  getDisciplineFailed,
  getDisciplineSuccess,
  deleteDisciplineSuccess,
  deleteDisciplineFailed,
} from "@actions/HRM/employee/discipline-actions";
import {
  CREATE_DISCIPLINE,
  UPDATE_DISCIPLINE,
  GET_DISCIPLINE_HISTORY,
  DELETE_DISCIPLINE_HISTORY,
} from "@actions/HRM/employee/types";

import {
  createDiscipline,
  updateDiscipline,
  getDisciplines,
  deleteDisciplineTable,
} from "@api/discipline";

import { isRequestCancelled } from "@helpers/routing";

export const disciplinesMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: AnyAction) => {
      const nextAction = next(action);
      switch (action.type) {
        case CREATE_DISCIPLINE.CREATE_DISCIPLINE_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await createDiscipline(payload);

            dispatch(createDisciplineSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(createDisciplineFailed());
            }
          }

          break;
        }

        case UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_REQUEST: {
          try {
            const { payload } = action as any;

            const { data } = await updateDiscipline(payload);

            dispatch(updateDisciplineSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateDisciplineFailed());
            }
          }

          break;
        }

        case GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getDisciplines(payload?.data);

            dispatch(getDisciplineSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getDisciplineFailed());
            }
          }

          break;
        }

        case DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteDisciplineTable(payload);

            dispatch(deleteDisciplineSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteDisciplineFailed());
            }
          }
          break;
        }

        default:
          break;
      }
      return nextAction;
    };
  };
};
